import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listShippingRates = (cartId) =>
  axios.get(
    `${getV1RootUrl()}/cart/${cartId}/shipping-rate`,
    publicAxiosHeader()
  );
